<template>
  <b-modal width="500px" :active.sync="isCardModalActive" :can-cancel="true">
    <ModalDetailSchedule
      :user=profile
      :users="users"
      :eventGroup="eventGroup"
      :isShowModal="isModalDetailSchedule"
      @cancel="changeDetailSchedule"
      v-if="isModalDetailSchedule"
    />
    <ModalDetailProfile
      :user=profile
      :isShowModal="isModalDetailProfile"
      @cancel="changeDetailProfile"
    />
    <div class="card" style="border-radius: 5px;" v-if="isCardModalActive">
      <header class="card-header">
        <div class="card-header-title edit-title-wrapper">
          <span class="edit-title">操作メニュー</span>
        </div>
      </header>
      <div class="card-content profile-box">
        <p class="name">{{profile.name}}</p>
        <p class="email">{{profile.email}}</p>
        <div class="left-box">
          <img class="img-icon" :src="profile.icon"/>
        </div>
        <div class="right-box">
          <p>アクションを選んでください。</p>
          <button class="button" style="margin: 4px;" @click="changeDetailSchedule(true)">予定</button>
          <button class="button" style="margin: 4px;" @click="openChatRoomUser(profile)">会話</button>
          <button class="button" style="margin: 4px;" @click="changeDetailProfile(true)">詳細</button>
        </div>
      </div>
      <button class="button is-fullwidth" @click="isCardModalActive = false">閉じる</button>
    </div>
  </b-modal>
</template>

<script>
import ModalDetailProfile  from '@/components/VirtualOffice/organisms/ModalDetailProfile'
import ModalDetailSchedule from '@/components/VirtualOffice/organisms/ModalDetailSchedule'
export default {
  components: {
    ModalDetailProfile,
    ModalDetailSchedule
  },
  props: {
    users: {
      type: Array,
      required: true
    },
    eventGroup: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      profile: null,
      isCardModalActive: false,
      isModalDetailSchedule: false,
      isModalDetailProfile: false
    }
  },
  methods: {
    changeDetailSchedule (flg) {
      this.isModalDetailSchedule = flg
    },
    changeDetailProfile (flg) {
      this.isModalDetailProfile = flg
    },
    openChatRoomUser (profile) {
      this.isCardModalActive = false
      this.$emit('openChatRoomUser', profile)
    }
  }
}
</script>

<style lang='scss' scoped>
.card-header {
  display: flex;
}
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.img-icon {
  width:  128px;
  height: 128px;
  object-fit: cover;
  border-radius: 50%;
}
.name {
  width: 440px;
  font-size: 20px;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.email {
  color: #666;
  width: 440px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.profile-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .name {
    width: 100%;
    border-left: solid 8px #a22;
    padding-left: 8px;
  }
  .email {
    width: 100%;
    font-size: 12px;
    border-left: solid 8px #a22;
    padding-left: 8px;
    color: #666;
    margin-bottom: 16px;
  }
  .left-box {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .right-box {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    p {
      width: 100%;
      font-weight: 600;
      margin-bottom: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/ModalShowProfile.vue